import "core-js/modules/es.array.reverse.js";
var _class, _GtfsStratum, _class2, _descriptor, _GtfsCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { get as _get } from "lodash-es";
import { computed, makeObservable, observable, runInAction } from "mobx";
import { createTransformer } from "mobx-utils";
import Pbf from "pbf";
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import Color from "terriajs-cesium/Source/Core/Color";
import HeadingPitchRoll from "terriajs-cesium/Source/Core/HeadingPitchRoll";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import NearFarScalar from "terriajs-cesium/Source/Core/NearFarScalar";
import Transforms from "terriajs-cesium/Source/Core/Transforms";
import BillboardGraphics from "terriajs-cesium/Source/DataSources/BillboardGraphics";
import ConstantPositionProperty from "terriajs-cesium/Source/DataSources/ConstantPositionProperty";
import ConstantProperty from "terriajs-cesium/Source/DataSources/ConstantProperty";
import DataSource from "terriajs-cesium/Source/DataSources/CustomDataSource";
import ModelGraphics from "terriajs-cesium/Source/DataSources/ModelGraphics";
import PointGraphics from "terriajs-cesium/Source/DataSources/PointGraphics";
import PropertyBag from "terriajs-cesium/Source/DataSources/PropertyBag";
import Axis from "terriajs-cesium/Source/Scene/Axis";
import ColorBlendMode from "terriajs-cesium/Source/Scene/ColorBlendMode";
import HeightReference from "terriajs-cesium/Source/Scene/HeightReference";
import ShadowMode from "terriajs-cesium/Source/Scene/ShadowMode";
import isDefined from "../../../Core/isDefined";
import loadArrayBuffer from "../../../Core/loadArrayBuffer";
import TerriaError from "../../../Core/TerriaError";
import AutoRefreshingMixin from "../../../ModelMixins/AutoRefreshingMixin";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import GtfsCatalogItemTraits from "../../../Traits/TraitsClasses/GtfsCatalogItemTraits";
import { RectangleTraits } from "../../../Traits/TraitsClasses/MappableTraits";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import { FeedMessageReader } from "./GtfsRealtimeProtoBufReaders";
import prettyPrintGtfsEntityField from "./prettyPrintGtfsEntityField";
let GtfsStratum = (_class = (_GtfsStratum = class GtfsStratum extends LoadableStratum(GtfsCatalogItemTraits) {
  constructor(_item) {
    super();
    this._item = _item;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new GtfsStratum(newModel);
  }
  static async load(item) {
    return new GtfsStratum(item);
  }
  get rectangle() {
    return createStratumInstance(RectangleTraits, this._item._bbox);
  }
}, _defineProperty(_GtfsStratum, "stratumName", "gtfs"), _GtfsStratum), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _class);
StratumOrder.addLoadStratum(GtfsStratum.stratumName);

/**
 * For displaying realtime transport data. See [here](https://developers.google.com/transit/gtfs-realtime/reference/)
 * for the spec.
 */
let GtfsCatalogItem = (_class2 = (_GtfsCatalogItem = class GtfsCatalogItem extends UrlMixin(AutoRefreshingMixin(MappableMixin(CatalogMemberMixin(CreateModel(GtfsCatalogItemTraits))))) {
  static get type() {
    return "gtfs";
  }
  get type() {
    return GtfsCatalogItem.type;
  }
  get dataSource() {
    this._dataSource.entities.suspendEvents();

    // Convert the GTFS protobuf into a more useful shape
    const vehicleData = this.convertManyFeedEntitiesToBillboardData(this.gtfsFeedEntities);
    for (const data of vehicleData) {
      if (data.sourceId === undefined) {
        continue;
      }
      const entity = this._dataSource.entities.getOrCreateEntity(data.sourceId);
      if (!entity.model) {
        if (this._coloredModels) {
          var _data$featureInfo;
          const gtfsEntity = (_data$featureInfo = data.featureInfo) === null || _data$featureInfo === void 0 ? void 0 : _data$featureInfo.get("entity");
          const value = _get(gtfsEntity, this.model.colorModelsByProperty.property);
          if (value !== undefined) {
            const index = this.model.colorModelsByProperty.colorGroups.findIndex(colorGroup => colorGroup.regExp !== undefined && new RegExp(colorGroup.regExp).test(value));
            if (index !== -1) {
              entity.model = this._coloredModels[index];
            }
            entity.point = undefined;
          } else {
            entity.model = this._model;
          }
        } else if (this._model) {
          entity.model = this._model;
        }
      }
      if (this.model !== undefined && this.model !== null && data.orientation !== undefined && data.orientation !== null) {
        entity.orientation = new ConstantProperty(data.orientation);
      }
      if (data.position !== undefined && (!entity.position || entity.position.getValue(new JulianDate()) !== data.position)) {
        entity.position = new ConstantPositionProperty(data.position);
      }

      // If we're using a billboard
      if (data.billboard !== null && data.billboard !== undefined) {
        if (entity.billboard === null || entity.billboard === undefined) {
          entity.billboard = data.billboard;
        }
        if (data.billboard.color) {
          data.billboard.color.getValue(new JulianDate()).alpha = this.opacity;
        }
        if (!entity.billboard.color || !entity.billboard.color.equals(data.billboard.color)) {
          entity.billboard.color = data.billboard.color;
        }
      }

      // If we're using a point
      if (data.point !== null && data.point !== undefined) {
        if (entity.point === null || entity.point === undefined) {
          entity.point = data.point;
        }
        if (data.point.color) {
          data.point.color.getValue(new JulianDate()).alpha = this.opacity;
        }
        if (!entity.point.color || !entity.point.color.equals(data.point.color)) {
          entity.point.color = data.point.color;
        }
      }
      if (data.featureInfo !== undefined && data.featureInfo !== null) {
        entity.properties = new PropertyBag();
        for (const key of data.featureInfo.keys()) {
          entity.properties.addProperty(key, data.featureInfo.get(key));
        }
      }
    }

    // remove entities that no longer exist
    if (this._dataSource.entities.values.length > vehicleData.length) {
      const idSet = new Set(vehicleData.map(val => val.sourceId));
      this._dataSource.entities.values.filter(entity => !idSet.has(entity.id)).forEach(entity => this._dataSource.entities.remove(entity));
    }
    this._dataSource.entities.resumeEvents();
    return this._dataSource;
  }
  refreshData() {
    this.forceLoadMapItems();
  }
  get mapItems() {
    this._dataSource.show = this.show;
    return [this.dataSource];
  }
  get _cesiumUpAxis() {
    if (this.model.upAxis === undefined) {
      return Axis.Y;
    }
    return Axis.fromName(this.model.upAxis);
  }
  get _cesiumForwardAxis() {
    if (this.model.forwardAxis === undefined) {
      return Axis.Z;
    }
    return Axis.fromName(this.model.forwardAxis);
  }
  get _model() {
    var _this$model$scale, _this$model$minimumPi;
    if (this.model.url === undefined) {
      return undefined;
    }
    const options = {
      uri: new ConstantProperty(this.model.url),
      upAxis: new ConstantProperty(this._cesiumUpAxis),
      forwardAxis: new ConstantProperty(this._cesiumForwardAxis),
      scale: new ConstantProperty((_this$model$scale = this.model.scale) !== null && _this$model$scale !== void 0 ? _this$model$scale : 1),
      heightReference: new ConstantProperty(HeightReference.RELATIVE_TO_GROUND),
      distanceDisplayCondition: new ConstantProperty({
        near: 0.0,
        far: this.model.maximumDistance
      }),
      maximumScale: new ConstantProperty(this.model.maximumScale),
      minimumPixelSize: new ConstantProperty((_this$model$minimumPi = this.model.minimumPixelSize) !== null && _this$model$minimumPi !== void 0 ? _this$model$minimumPi : 0),
      shadows: ShadowMode.DISABLED
    };
    return new ModelGraphics(options);
  }
  get _coloredModels() {
    var _this$model, _this$model2;
    const colorGroups = (_this$model = this.model) === null || _this$model === void 0 || (_this$model = _this$model.colorModelsByProperty) === null || _this$model === void 0 ? void 0 : _this$model.colorGroups;
    const model = this._model;
    if (!isDefined(model) || !isDefined((_this$model2 = this.model) === null || _this$model2 === void 0 || (_this$model2 = _this$model2.colorModelsByProperty) === null || _this$model2 === void 0 ? void 0 : _this$model2.property) || !isDefined(colorGroups) || colorGroups.length === 0) {
      return undefined;
    }
    return colorGroups.map(_ref => {
      let {
        color
      } = _ref;
      const coloredModel = model.clone();
      coloredModel.color = new ConstantProperty(Color.fromCssColorString(color !== null && color !== void 0 ? color : "white"));
      coloredModel.colorBlendMode = new ConstantProperty(ColorBlendMode.MIX);
      coloredModel.colorBlendAmount = new ConstantProperty(0.7);
      return coloredModel;
    });
  }
  constructor(id, terria, sourceReference) {
    super(id, terria, sourceReference);
    _defineProperty(this, "disposer", void 0);
    _defineProperty(this, "_bbox", {
      west: Infinity,
      south: Infinity,
      east: -Infinity,
      north: -Infinity
    });
    /**
     * Always use the getter to read this. This is a cache for a computed property.
     *
     * We cache it because recreating it reactively is computationally expensive, so we modify it reactively instead.
     */
    _defineProperty(this, "_dataSource", new DataSource("billboard"));
    _initializerDefineProperty(this, "gtfsFeedEntities", _descriptor, this);
    _defineProperty(this, "convertManyFeedEntitiesToBillboardData", createTransformer(feedEntities => {
      // Sometimes the feed can contain many records for the same vehicle
      // so we'll only display the newest record.
      // Although technically the timestamp property is optional, if none is
      // present we'll show the record.
      const vehicleMap = new Map();
      for (let i = 0; i < feedEntities.length; ++i) {
        const entity = feedEntities[i];
        const item = this.convertFeedEntityToBillboardData(entity);
        if (item && item.position && item.featureInfo) {
          const vehicleInfo = item.featureInfo.get("entity").vehicle.vehicle;
          if (vehicleMap.has(vehicleInfo.id) && vehicleInfo.timestamp) {
            const existingRecord = vehicleMap.get(vehicleInfo.id);
            if (existingRecord.timestamp < vehicleInfo.timestamp) {
              vehicleMap.set(vehicleInfo.id, item);
            }
          } else {
            vehicleMap.set(vehicleInfo.id, item);
          }
        }
      }
      return [...vehicleMap.values()];
    }));
    makeObservable(this);
  }
  forceLoadMetadata() {
    return Promise.resolve();
  }
  forceLoadMapItems() {
    if (this.strata.get(GtfsStratum.stratumName) === undefined) {
      GtfsStratum.load(this).then(stratum => {
        runInAction(() => {
          this.strata.set(GtfsStratum.stratumName, stratum);
        });
      });
    }
    const promise = this.retrieveData().then(data => {
      runInAction(() => {
        if (data.entity !== undefined && data.entity !== null) {
          this.gtfsFeedEntities = data.entity;
          this.terria.currentViewer.notifyRepaintRequired();
        }
      });
    }).catch(_e => {
      throw new TerriaError({
        title: "Could not load ".concat(this.nameInCatalog, "."),
        sender: this,
        message: "There was an error loading the data for ".concat(this.nameInCatalog, ".")
      });
    });
    return promise;
  }
  retrieveData() {
    // These headers work for the Transport for NSW APIs. Presumably, other services will require different headers.
    const headers = {
      "Content-Type": "application/x-google-protobuf;charset=UTF-8",
      "Cache-Control": "no-cache"
    };
    if (this.headers !== undefined) {
      this.headers.forEach(_ref2 => {
        let {
          name,
          value
        } = _ref2;
        if (name !== undefined && value !== undefined) headers[name] = value;
      });
    }
    if (this.url !== null && this.url !== undefined) {
      return loadArrayBuffer(proxyCatalogItemUrl(this, this.url), headers).then(arr => {
        const pbfBuffer = new Pbf(new Uint8Array(arr));
        return new FeedMessageReader().read(pbfBuffer);
      });
    } else {
      return Promise.reject();
    }
  }
  convertFeedEntityToBillboardData(entity) {
    if (entity.id === undefined) {
      return {};
    }
    let position = undefined;
    let orientation = undefined;
    const featureInfo = new Map();
    if (entity.vehicle !== null && entity.vehicle !== undefined && entity.vehicle.position !== null && entity.vehicle.position !== undefined && entity.vehicle.position.latitude !== null && entity.vehicle.position.latitude !== undefined && entity.vehicle.position.longitude !== null && entity.vehicle.position.longitude !== undefined && entity.vehicle.position.bearing !== null && entity.vehicle.position.bearing !== undefined) {
      updateBbox(entity.vehicle.position.latitude, entity.vehicle.position.longitude, this._bbox);
      position = Cartesian3.fromDegrees(entity.vehicle.position.longitude, entity.vehicle.position.latitude);
      orientation = Transforms.headingPitchRollQuaternion(position, HeadingPitchRoll.fromDegrees(entity.vehicle.position.bearing - 90.0, 0.0, 0.0));
    }

    // Add the values that the feature info template gets populated with
    for (const field of GtfsCatalogItem.FEATURE_INFO_TEMPLATE_FIELDS) {
      featureInfo.set(field, prettyPrintGtfsEntityField(field, entity));
    }
    featureInfo.set("entity", entity);
    let billboard;
    let point;
    if (this.image !== undefined && this.image !== null) {
      billboard = new BillboardGraphics({
        image: new ConstantProperty(this.image),
        heightReference: new ConstantProperty(HeightReference.RELATIVE_TO_GROUND),
        scaleByDistance: this.scaleImageByDistance.nearValue === this.scaleImageByDistance.farValue ? undefined : new ConstantProperty(new NearFarScalar(this.scaleImageByDistance.near, this.scaleImageByDistance.nearValue, this.scaleImageByDistance.far, this.scaleImageByDistance.farValue)),
        scale: this.scaleImageByDistance.nearValue === this.scaleImageByDistance.farValue && this.scaleImageByDistance.nearValue !== 1.0 ? new ConstantProperty(this.scaleImageByDistance.nearValue) : undefined,
        color: new ConstantProperty(new Color(1.0, 1.0, 1.0, this.opacity))
      });
    } else {
      point = new PointGraphics({
        color: new ConstantProperty(Color.CYAN),
        outlineWidth: new ConstantProperty(1),
        outlineColor: new ConstantProperty(Color.WHITE),
        scaleByDistance: this.scaleImageByDistance.nearValue === this.scaleImageByDistance.farValue ? undefined : new ConstantProperty(new NearFarScalar(this.scaleImageByDistance.near, this.scaleImageByDistance.nearValue, this.scaleImageByDistance.far, this.scaleImageByDistance.farValue)),
        pixelSize: this.scaleImageByDistance.nearValue === this.scaleImageByDistance.farValue && this.scaleImageByDistance.nearValue !== 1.0 ? new ConstantProperty(32 * this.scaleImageByDistance.nearValue) : new ConstantProperty(32),
        heightReference: new ConstantProperty(HeightReference.RELATIVE_TO_GROUND)
      });
    }
    return {
      sourceId: entity.id,
      position: position,
      orientation: orientation,
      featureInfo: featureInfo,
      billboard: billboard,
      point: point
    };
  }
}, _defineProperty(_GtfsCatalogItem, "FEATURE_INFO_TEMPLATE_FIELDS", ["route_short_name", "occupancy_status#str", "speed#km", "speed", "bearing"]), _GtfsCatalogItem), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "gtfsFeedEntities", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "dataSource", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dataSource"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_cesiumUpAxis", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_cesiumUpAxis"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_cesiumForwardAxis", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_cesiumForwardAxis"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_model", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_model"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_coloredModels", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_coloredModels"), _class2.prototype), _class2);
export { GtfsCatalogItem as default };
function updateBbox(lat, lon, rectangle) {
  if (lon < rectangle.west) rectangle.west = lon;
  if (lat < rectangle.south) rectangle.south = lat;
  if (lon > rectangle.east) rectangle.east = lon;
  if (lat > rectangle.north) rectangle.north = lat;
}